export default {"src":"/_next/static/media/requirements_template.37800b05.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};